// extracted by mini-css-extract-plugin
export var container = "bG_b";
export var email = "bG_ht";
export var emails = "bG_hs";
export var location = "bG_cF";
export var number = "bG_cf";
export var numbers = "bG_cd";